import { z } from 'zod';
import { ProcessCategorySchema, ProcessStatusSchema, DerivedInputPortSchema, DerivedOutputPortSchema } from '../../entities/process/process.schema';
import { ProcessMapLaneDimensionSchema } from '../../shared/process-map.schema';
/**
 * Process Map Node Schema
 * A process with aggregated metrics for the process landscape view
 */ export const ProcessMapNodeSchema = z.object({
    _id: z.string(),
    name: z.string(),
    category: ProcessCategorySchema.optional(),
    department: z.object({
        _id: z.string(),
        name: z.string()
    }),
    owner: z.object({
        _id: z.string(),
        firstName: z.string(),
        lastName: z.string()
    }).optional(),
    metrics: z.object({
        totalSteps: z.number(),
        totalParticipants: z.number(),
        recordingStatus: ProcessStatusSchema
    }),
    inputs: z.array(DerivedInputPortSchema).optional(),
    outputs: z.array(DerivedOutputPortSchema).optional(),
    mapPosition: z.object({
        x: z.number(),
        y: z.number()
    }).optional()
});
/**
 * Process Map Edge Schema
 * A directed connection between two processes
 */ export const ProcessMapEdgeSchema = z.object({
    _id: z.string().optional(),
    source: z.string(),
    target: z.string(),
    sourcePortKey: z.string().optional(),
    targetPortKey: z.string().optional(),
    connectionType: z.enum([
        'end_to_start',
        'port_to_port'
    ])
});
/**
 * Process Map Summary Schema
 * Organization-wide KPIs for the process landscape
 */ export const ProcessMapSummarySchema = z.object({
    totalProcesses: z.number(),
    coreProcesses: z.number(),
    managementProcesses: z.number(),
    supportProcesses: z.number(),
    uncategorizedProcesses: z.number(),
    totalConnections: z.number(),
    isolatedProcesses: z.number(),
    longestChain: z.number()
});
/**
 * Process Map Response Schema
 * GET /api/v2/process/map
 */ export const GetProcessMapResponseSchema = z.object({
    data: z.object({
        processes: z.array(ProcessMapNodeSchema),
        edges: z.array(ProcessMapEdgeSchema),
        summary: ProcessMapSummarySchema,
        laneDimensions: z.array(ProcessMapLaneDimensionSchema).optional()
    })
});

//# sourceMappingURL=get-process-map.schema.js.map